var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCanadaSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 16C32.0005 9.65661 28.309 4.17562 22.957 1.58762V30.4123C28.309 27.8244 32.0005 22.3434 32.0005 16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 22.3434 3.69156 27.8244 9.0435 30.4124V1.58762C3.69156 4.17562 0 9.65661 0 16Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7834 18.0869L21.5659 16.6956L20.1747 16V14.6087L17.392 16L18.7834 13.2174H17.392L16.0007 11.1304L14.6094 13.2174H13.2181L14.6094 16L11.8268 14.6087V16L10.4355 16.6956L13.2181 18.0869L12.5225 19.4782H15.3051V21.5652H16.6964V19.4782H19.479L18.7834 18.0869Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCanadaSmall);
export default __webpack_public_path__ + "static/media/flagCanadaSmall.d8e54fe9e910187836c39b9f7e2a303d.svg";
export { ForwardRef as ReactComponent };